import { render, staticRenderFns } from "./CMessage.vue?vue&type=template&id=6803d1ba"
import script from "./CMessage.vue?vue&type=script&lang=js"
export * from "./CMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports